import styled from 'styled-components';

export const H1 = styled.h1`
  font-size: 58px;
  line-height: 73px;
  color: ${prop => prop.color};
`;

export const H3 = styled.h3`
  font-size: 38px;
  line-height: 49px;
  color: ${prop => prop.color};
`;

export const H4 = styled.h4`
  font-size: 28px;
  line-height: 37px;
  color: ${prop => prop.color};
`;

export const H5 = styled.h5`
  font-size: 18px;
  line-height: 24px;
  color: ${prop => prop.color};
`;

export const H6 = styled.h6`
  font-size: 14px;
  line-height: 20px;
  font-weight: ${prop => prop.semibold ? 600 : 'normal'};
  color: ${prop => prop.color};
`;

export const P = styled.p`
  font-size: 12px;
  line-height: 17px;
  font-weight: ${prop => prop.bold ? 'bold' : 'normal'};
  color: ${prop => prop.color};
`;

export const Hyperlink = styled.a`
  font-size: 12px;
  line-height: 17px;
  text-decoration-line: underline;
  color: ${prop => prop.color};
`
export const Small = styled.small`
  font-size: 8px;
  line-height: 12px;
  color: ${prop => prop.color};
`;
